<!--添加报告（第二步） - 对比报告 -->
<template>
    <a-spin :spinning="boxSpinning">
        <div class="steps-second" style="position: relative;">
            <div v-if="!IsDetails" style="margin: 30px 0;">
                <a-button :loading="sampleModel.confirmLoading" @click="addSample(false)" type="primary" icon="plus">
                    添加对比样本
                </a-button>
            </div>
            <a-page-header :ghost="false"
                           v-for="(item, index) in groupReportList"
                           style="border: 1px solid rgb(235, 237, 240);margin-bottom: 30px;"
                           :title="item.sampleName"
                           :backIcon="false">
                <template v-if="!IsDetails" slot="extra">
                    <a-button @click="editSample(item)" key="1" type="link">
                        修改名称
                    </a-button>
                    <a-popconfirm title="确认删除此样本？" @confirm="delSample(item)">
                        <a-button key="2" style="color:#f00;" type="link">
                            删除样本
                        </a-button>
                    </a-popconfirm>
                </template>
                <a-card>
                    <AssessReport :IsDetails="IsDetails" :groupReportContrastSampleId="item.id"/>
                </a-card>
            </a-page-header>
        </div>
        <!--修改对比样本名称-->
        <a-modal v-model="sampleModel.visible"
                 :centered="true"
                 :destroyOnClose="true"
                 title="修改样本名称"
                 :confirm-loading="sampleModel.confirmLoading"
                 @cancel="sampleModelCancel"
                 @ok="sampleModelOk" width="500px">
            <a-form-model ref="sampleModelForm"
                          :model="sampleModel.data"
                          :rules="sampleModel.rules"
                          :label-col="{span:6}"
                          :wrapper-col="{span:14}">
                <a-form-model-item label="样本名称" prop="sampleName">
                    <a-input v-model="sampleModel.data.sampleName" placeholder="请输入样本名称"/>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </a-spin>
</template>

<script>
    import AssessReport from "./AssessReport";

    export default {
        name: "ContrastReport",
        components: {AssessReport},
        props:{
            IsDetails: false,
        },
        data() {
            return {
                boxSpinning: false,
                //当前报告信息
                reportInfo: this.$store.getters['organization/getReportInfo'],
                //对比样本列表
                groupReportList: [],
                sampleModel: {
                    visible: false,
                    confirmLoading: false,
                    data: {
                        id: undefined,
                        sampleName: "",
                        GroupReportId: this.$store.getters['organization/getReportInfo'].id
                    },
                    rules: {
                        sampleName: [
                            {required: true, message: '请输入样本名称', trigger: 'blur'},
                            {min: 2, max: 25, message: '样本名称长度为2 到 25 个字符', trigger: 'blur'},
                        ]
                    }
                }
            }
        },
        mounted() {
            this.getListByGroupReport();
        },
        methods: {
            //获取对比样本列表
            async getListByGroupReport() {
                this.groupReportList = [];
                this.boxSpinning = true;
                await this.$http.GroupReport.getListByGroupReport({reportid: this.reportInfo.id}).then(res => {
                    this.groupReportList = res.data.reverse();
                }).finally(() => {
                  this.boxSpinning = false;
                })
            },
            // 添加对比样本
            addSample(isEdit) {
                if (!isEdit) {
                    this.sampleModel.data.id = undefined;
                    this.sampleModel.data.sampleName = "默认名称" + (this.groupReportList.length + 1);
                }
                const form = new URLSearchParams();
                for (let key in this.sampleModel.data) {
                    if (this.sampleModel.data[key]) {
                        form.append(key, this.sampleModel.data[key])
                    }
                }
                this.sampleModel.confirmLoading = true;
                this.$http.GroupReport.editSample(form).then(res => {
                    this.sampleModel.visible = false;
                    this.$message.success(res.message);
                    this.getListByGroupReport();
                }).finally(() => {
                  this.sampleModel.confirmLoading = false;
                })
            },
            // 编辑对比样本
            editSample(val) {
                this.sampleModel.visible = true;
                this.sampleModel.data.sampleName = val.sampleName;
                this.sampleModel.data.id = val.id;
            },
            // 删除对比样本
            delSample(item) {
                this.$http.GroupReport.delSample(new URLSearchParams({id: item.id})).then(res => {
                    this.$message.success(res.message);
                    this.getListByGroupReport();
                })
            },
            // 对比样本弹框关闭
            sampleModelCancel() {
                this.sampleModel.visible = false;
                this.$refs["sampleModelForm"].resetFields();
                this.sampleModel.data.sampleName = "";
            },
            // 对比样本弹框确认
            sampleModelOk() {
                this.$refs["sampleModelForm"].validate(valid => {
                    if (valid) {
                        this.addSample(true);
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>
